<template>
  <div class="product-management">
    <el-card shadow="hover">
      <template slot="header">
        <div class="card-header">
          <span>商品管理</span>
          <el-button class="btn-primary" icon="el-icon-plus" @click="openCreate">添加商品</el-button>
        </div>
      </template>
      <el-table :data="products" style="width: 100%" class="product-table">
        <el-table-column prop="id" label="商品ID"></el-table-column>
        <el-table-column label="商品图片" width="100">
          <template slot-scope="scope">
            <el-image
              :src="scope.row.image_url"
              style="width: 60px; height: 60px; border-radius: 6px;"
              fit="cover"
            >
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="商品名称"></el-table-column>
        <el-table-column prop="price" label="价格"></el-table-column>
        <el-table-column prop="category" label="分类"></el-table-column>
        <el-table-column prop="stock" label="库存"></el-table-column>
        <el-table-column prop="createdAt" label="创建时间"></el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button
              size="small"
              class="btn-secondary"
              @click="editProduct(scope.row)"
            >
              编辑
            </el-button>
            <el-button
              size="small"
              class="btn-secondary danger"
              @click="deleteProduct(scope.row.id)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog
      :title="dialogMode === 'create' ? '添加商品' : '编辑商品'"
      :visible.sync="dialogVisible"
      width="520px"
      destroy-on-close
      append-to-body
    >
      <el-form :key="formFormKey" :model="form" :rules="rules" ref="productForm" label-width="100px">
        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入商品名称"></el-input>
        </el-form-item>
        <el-form-item label="分类" prop="category">
          <el-select v-model="form.category" placeholder="请选择分类" style="width: 100%;">
            <el-option
              v-for="c in categoryOptions"
              :key="c"
              :label="c"
              :value="c"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="价格" prop="price">
          <el-input v-model="form.price" placeholder="例如：25"></el-input>
        </el-form-item>
        <el-form-item label="库存" prop="stock">
          <el-input v-model="form.stock" placeholder="例如：100"></el-input>
        </el-form-item>
        <el-form-item label="商品图片">
          <el-upload
            class="avatar-uploader"
            :show-file-list="false"
            :http-request="handleImageUpload"
            accept="image/*"
          >
            <img v-if="form.image_url" :src="form.image_url" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="描述">
          <el-input type="textarea" :rows="3" v-model="form.description" placeholder="可选"></el-input>
        </el-form-item>
        <el-form-item label="随心订餐次" v-if="form.category === '随心订'">
          <el-radio-group v-model="form.subscription_meals_mode">
            <el-radio label="lunch">仅午餐</el-radio>
            <el-radio label="dinner">仅晚餐</el-radio>
            <el-radio label="both">午餐+晚餐</el-radio>
          </el-radio-group>
          <div class="meal-tip">此处为<strong>固定配置</strong>：小程序「随心订」页将按此配送，用户<strong>不可更改</strong>餐次。</div>
        </el-form-item>
        <el-form-item label="总购买餐次" prop="subscription_total_meals" v-if="form.category === '随心订'">
          <el-input-number
            v-model="form.subscription_total_meals"
            :min="1"
            :max="9999"
            :step="1"
            :precision="0"
            controls-position="right"
            style="width: 100%;"
            @change="onTotalMealsChange"
          />
          <div class="meal-tip">
            手动填写顾客购买的总餐次数（正整数）。系统按有效工作日自动排餐：仅午餐/晚餐每日消耗 1 餐次，午餐+晚餐每日消耗 2 餐次；跳过周末与法定节假日，调休工作日正常配送。
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn-secondary" @click="dialogVisible = false">取消</el-button>
        <el-button class="btn-primary" :loading="saving" @click="submit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { fetchProducts, createProduct, updateProduct, deleteProductApi } from '../api/products';
import { formatApiError } from '../utils/apiError';

/** 与小程序「订购套餐」分类 Tab 一致 */
const CATEGORY_OPTIONS = ['随心订', '下午茶', '小食', '饮品']

export default {
  name: 'ProductManagement',
  data() {
    const validateTotalMeals = (rule, value, callback) => {
      if (this.form.category !== '随心订') {
        callback()
        return
      }
      const n = Math.floor(Number(value))
      if (!Number.isFinite(n) || n < 1) {
        callback(new Error('总购买餐次须为 1 及以上的正整数'))
        return
      }
      callback()
    }
    return {
      categoryOptions: CATEGORY_OPTIONS,
      products: [],
      dialogVisible: false,
      dialogMode: 'create',
      saving: false,
      currentId: null,
      form: {
        name: '',
        category: '',
        price: '',
        stock: '',
        image_url: '',
        description: '',
        subscription_meals: ['lunch', 'dinner'],
        subscription_meals_mode: 'both',
        subscription_total_meals: 10
      },
      formFormKey: 0,
      rules: {
        name: [{ required: true, message: '请输入商品名称', trigger: 'blur' }],
        category: [{ required: true, message: '请选择分类', trigger: 'change' }],
        price: [
          { required: true, message: '请输入价格', trigger: 'blur' },
          { pattern: /^\d+(\.\d+)?$/, message: '价格格式不正确', trigger: 'blur' }
        ],
        stock: [{ pattern: /^\d+$/, message: '库存必须是整数', trigger: 'blur' }],
        subscription_total_meals: [{ validator: validateTotalMeals, trigger: 'change' }]
      }
    }
  },
  mounted() {
    this.getProducts();
  },
  methods: {
    mealsModeFromProduct(meals) {
      const arr = Array.isArray(meals) ? meals : []
      let hasL = false
      let hasD = false
      arr.forEach((s) => {
        const t = String(s).trim().toLowerCase()
        const z = String(s).trim()
        if (t === 'lunch' || z === '午餐') hasL = true
        if (t === 'dinner' || z === '晚餐') hasD = true
      })
      if (hasL && hasD) return 'both'
      if (hasL) return 'lunch'
      if (hasD) return 'dinner'
      return 'both'
    },
    mealsModeToPayload(mode) {
      if (mode === 'lunch') return ['lunch']
      if (mode === 'dinner') return ['dinner']
      return ['lunch', 'dinner']
    },
    resolveTotalMealsFromProduct(product) {
      const direct = Math.floor(Number(product && product.subscription_total_meals))
      if (direct >= 1) return direct
      const meals = Array.isArray(product && product.subscription_meals) ? product.subscription_meals : ['lunch', 'dinner']
      let days = 5
      if (product && product.subscription_fixed_workdays != null) {
        days = parseInt(String(product.subscription_fixed_workdays), 10) || 5
      } else if (product && Array.isArray(product.subscription_day_options) && product.subscription_day_options.length) {
        days = parseInt(String(product.subscription_day_options[0]), 10) || 5
      }
      return Math.max(1, days * Math.max(1, meals.length))
    },
    onTotalMealsChange(val) {
      const n = Math.floor(Number(val))
      if (!Number.isFinite(n) || n < 1) {
        this.$message.warning('总购买餐次须为 1 及以上的正整数')
        this.$nextTick(() => {
          this.form.subscription_total_meals = 1
        })
      }
    },
    async getProducts() {
      try {
        const data = await fetchProducts();
        if (data && data.code === 200 && Array.isArray(data.data)) {
          this.products = data.data;
          localStorage.setItem('dashboard_product_count', String(this.products.length));
          return;
        }
        throw new Error('invalid response');
      } catch (e) {
        this.products = [
          {
            id: '1',
            name: '测试套餐A',
            price: 35,
            category: '随心订',
            stock: 99,
            createdAt: '2026-03-10 09:00:00',
            image_url: 'https://picsum.photos/200/200?random=11',
            subscription_meals: ['lunch', 'dinner'],
            subscription_total_meals: 10
          },
          {
            id: '2',
            name: '测试轻食B',
            price: 28,
            category: '小食',
            stock: 88,
            createdAt: '2026-03-10 10:00:00',
            image_url: 'https://picsum.photos/200/200?random=12'
          }
        ];
        localStorage.setItem('dashboard_product_count', String(this.products.length));
        this.$message.warning(
          `${formatApiError(e, '商品接口不可用')}；已加载测试数据`
        );
      }
    },
    async handleImageUpload(param) {
      if (!param.file) return;
      const formData = new FormData();
      formData.append('file', param.file);
      try {
        const resp = await this.$api.post('/products/upload-image', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        if (resp && resp.code === 200 && resp.data && resp.data.url) {
          this.form.image_url = resp.data.url;
          this.$message.success('图片上传成功');
        } else {
          this.$message.error('图片上传失败');
        }
      } catch (e) {
        this.$message.error('图片上传失败');
      } finally {
        param.onSuccess && param.onSuccess();
      }
    },
    openCreate() {
      this.dialogMode = 'create';
      this.currentId = null;
      this.formFormKey += 1;
      this.form = {
        name: '',
        category: CATEGORY_OPTIONS[0],
        price: '',
        stock: '',
        image_url: '',
        description: '',
        subscription_meals: ['lunch', 'dinner'],
        subscription_meals_mode: 'both',
        subscription_total_meals: 10
      };
      this.dialogVisible = true;
      this.$nextTick(() => this.$refs.productForm && this.$refs.productForm.clearValidate());
    },
    editProduct(product) {
      this.dialogMode = 'edit';
      this.currentId = product.id;
      this.formFormKey += 1;
      const cat = product.category || ''
      this.form = {
        name: product.name || '',
        category: CATEGORY_OPTIONS.includes(cat) ? cat : CATEGORY_OPTIONS[0],
        price: product.price === undefined ? '' : String(product.price),
        stock: product.stock === undefined ? '' : String(product.stock),
        image_url: product.image_url || '',
        description: product.description || '',
        subscription_meals:
          Array.isArray(product.subscription_meals) && product.subscription_meals.length
            ? product.subscription_meals.slice()
            : ['lunch', 'dinner'],
        subscription_meals_mode: this.mealsModeFromProduct(product.subscription_meals),
        subscription_total_meals: this.resolveTotalMealsFromProduct(product)
      };
      this.dialogVisible = true;
      this.$nextTick(() => this.$refs.productForm && this.$refs.productForm.clearValidate());
    },
    async submit() {
      this.$refs.productForm.validate(async (valid) => {
        if (!valid) return;
        if (this.form.category === '随心订') {
          const n = Math.floor(Number(this.form.subscription_total_meals))
          if (!Number.isFinite(n) || n < 1) {
            this.$message.error('总购买餐次须为 1 及以上的正整数')
            return
          }
        }
        this.saving = true;
        try {
          const payload = {
            name: this.form.name,
            category: this.form.category,
            price: Number(this.form.price),
            stock: this.form.stock === '' ? 0 : Number(this.form.stock),
            image_url: this.form.image_url,
            description: this.form.description
          };
          if (this.form.category === '随心订') {
            payload.subscription_meals = this.mealsModeToPayload(this.form.subscription_meals_mode)
            payload.subscription_total_meals = Math.floor(Number(this.form.subscription_total_meals))
          }

          if (this.dialogMode === 'create') {
            await createProduct(payload);
            this.$message.success('添加成功');
          } else {
            await updateProduct(this.currentId, payload);
            this.$message.success('更新成功');
          }
          this.dialogVisible = false;
          await this.getProducts();
        } catch (e) {
          this.$message.error(this.dialogMode === 'create' ? '添加失败' : '更新失败');
        } finally {
          this.saving = false;
        }
      });
    },
    async deleteProduct(productId) {
      try {
        await this.$confirm('确定删除该商品吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        await deleteProductApi(productId);
        this.$message.success('删除成功');
        await this.getProducts();
      } catch (e) {
        // cancelled or error
      }
    }
  }
}
</script>

<style scoped>
.product-management {
  padding: 20px;
}

.action-btn-column {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.image-slot {
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f7fa;
  color: #c0c4cc;
  border-radius: 6px;
}

.avatar-uploader {
  display: inline-block;
}

.avatar {
  width: 80px;
  height: 80px;
  display: block;
  border-radius: 6px;
  object-fit: cover;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
}

.meal-tip {
  margin-top: 6px;
  font-size: 12px;
  color: #909399;
  line-height: 1.5;
}
</style>
